class FreeShippingBar extends HTMLElement {
  constructor() {
    super();
    // CUSTOM IFB — soglia per paese passata dal tema (centesimi di euro); 0 = nessuna spedizione gratuita
    const ifbCents = this.getAttribute('data-ifb-threshold-cents');
    const baseThreshold = ifbCents !== null ? parseInt(ifbCents, 10) / 100 : parseFloat(this.getAttribute('threshold')) || 200;
    this.ifbNoFreeShipping = ifbCents !== null && parseInt(ifbCents, 10) === 0;
    // CUSTOM IFB — niente arrotondamento all'euro: 99,99 resta 99,99
    this.threshold = Math.round(baseThreshold * (window.Shopify?.currency?.rate || 1) * 100) / 100;
    this.currencySymbol = window.currencySymbol || "$";
  }

  connectedCallback() {
    this.messageEl = this.querySelector('.free-shipping-text');
    this.progressEl = this.querySelector('.free-shipping-progress');
    if (!this.messageEl || !this.progressEl) return;
    this.updateFromCart();
  }

  updateFromCart() {
    fetch('/cart.js')
      .then((res) => res.json())
      .then((cart) => {
        // CUSTOM IFB — le carte regalo non contano per la spedizione gratuita (come al checkout di Shopify)
        if (this.ifbNoFreeShipping) {
          this.hidden = true;
          return;
        }
        const ifbItems = cart.items.filter((item) => !item.gift_card);
        // Solo carte regalo nel carrello: niente spedizione, la barra non serve
        if (!ifbItems.length) {
          this.hidden = true;
          return;
        }
        this.hidden = false;
        const cartTotal = ifbItems.reduce((sum, item) => sum + item.final_line_price, 0) / 100;
        this.updateProgress(cartTotal);
      });
  }

  // CUSTOM IFB — importo nel formato della lingua e della valuta del visitatore (es. 50,24 €)
  ifbFormat(amount) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'it', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'EUR',
      }).format(amount);
    } catch (e) {
      return this.currencySymbol + amount.toFixed(2);
    }
  }

  updateProgress(cartTotal) {
    const amountLeft = this.threshold - cartTotal;
    const percent = Math.min((cartTotal / this.threshold) * 100, 100);

    this.messageEl.innerHTML =
      amountLeft > 0
        ? `${window.ShippingProgress.free_shipping_remaining.replace('{{ amount }}', this.ifbFormat(amountLeft))}`
        : `${window.ShippingProgress.free_shipping_qualified}`;
    this.progressEl.style.width = percent + '%';
  }
}

if (!customElements.get('free-shipping-bar')) {
  customElements.define('free-shipping-bar', FreeShippingBar);
}



document.addEventListener('click', (e) => {
  const isQtyButton = e.target.closest('.quantity__button');
  const isRemoveBtn = e.target.closest('[href*="/cart/change"]') || e.target.closest('button[name="updates[]"][value="0"]');

  if (isQtyButton || isRemoveBtn) {
    setTimeout(() => {
      document.querySelectorAll('free-shipping-bar').forEach((bar) => {
        bar.updateFromCart?.();
      });
    }, 2000);
  }
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('free-shipping-bar').forEach((bar) => {
    bar.updateFromCart?.();
  });
});